<ul class="btn-group layout-view-container" *ngIf="layoutView$ | async as layoutView">
  <li class="btn btn-white btn-filter item-select" [class.active]="layoutView === 'list-view'" (click)="setLayoutView('list-view')">
    <i class="fa fa-list-ul m-0"></i>
  </li>
  <li class="btn btn-white btn-filter item-select" [class.active]="layoutView === 'card-view'" (click)="setLayoutView('card-view')">
    <i class="fa fa-th m-0"></i>
  </li>
</ul>
